
const capitalizeFirst = str =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`

const capitalizeAll = (str) => {
  return str
    .split(' ')
    .map(item => capitalizeFirst(item))
    .join(' ')
}

const HTML_ENTITIES = {
  '&': '&amp;',
  "'": '&#39;',
  '"': '&quot;',
  '<': '&lt;',
  '>': '&gt;'
}

const encodeHTML = (text) => {
  if (!text) {
    return text
  }

  const re = new RegExp(Object.keys(HTML_ENTITIES).join('|'), 'g')
  return text.replace(re, match => HTML_ENTITIES[match])
}

const sanitize = (str) => {
  return encodeHTML(str)
}

module.exports = (value, format, lng) => {
  if (typeof value === 'string') {
    switch (format) {
      case 'uppercase':
        return value.toUpperCase()
      case 'capitalize':
        return capitalizeAll(value)
      case 'lowercase':
        return value.toLowerCase()
      case 'sentence':
        return capitalizeFirst(value)
      case 'sanitize':
        return sanitize(value)
      default:
        return value
    }
  } else {
    return value
  }
}
